import { Reveal } from '../components/Reveal';
import { PlayDot } from '../components/Atoms';
import { FEED_ROWS } from '../data/feed';

function Phone() {
  return (
    <Reveal className="phone" aria-hidden="true">
      <div className="notch" />
      <div className="head">
        <span className="h-title">Le fil</span>
        <span className="h-meta">JEUDI · 23:41</span>
      </div>
      {FEED_ROWS.map((r) => (
        <div key={r.initial} className="row">
          <div className={`av ${r.color}`}>{r.initial}</div>
          <div>
            <div className="top">
              <span className="nm">{r.name}</span>
              <span className="pf">{r.pf}</span>
              <span>· {r.when}</span>
            </div>
            <div className="tk">{r.track}</div>
            <div className="ar">{r.artist}</div>
          </div>
          <div className="play"><PlayDot /></div>
        </div>
      ))}
    </Reveal>
  );
}

function Console() {
  return (
    <Reveal className="console">
      <div className="bar">
        <span className="d" /><span className="d" /><span className="d" />
        <span className="url">furtif.fm/fil</span>
        <span className="right">live · 7 amis</span>
      </div>
      <div className="head">
        <span /><span>ami / morceau</span><span>plateforme</span><span>quand</span>
      </div>
      <div className="crow live">
        <div className="av av-terra">L</div>
        <div className="info">
          <span className="who"><span className="nm">Léo</span> · écoute en ce moment</span>
          <span className="tk">Black Classical Music — <em>Yussef Dayes</em></span>
        </div>
        <span className="pf">SCD</span><span className="when">· now</span>
      </div>
      <div className="crow">
        <div className="av av-moss">M</div>
        <div className="info">
          <span className="who"><span className="nm">Mira</span></span>
          <span className="tk">Journey in Satchidananda — <em>Alice Coltrane</em></span>
        </div>
        <span className="pf">APL</span><span className="when">· 12m</span>
      </div>
      <div className="crow">
        <div className="av av-glow">S</div>
        <div className="info">
          <span className="who"><span className="nm">Sami</span></span>
          <span className="tk">Crush, live Maida Vale — <em>Floating Points</em></span>
        </div>
        <span className="pf">YTM</span><span className="when">· 28m</span>
      </div>
      <div className="crow">
        <div className="av av-warm">N</div>
        <div className="info">
          <span className="who"><span className="nm">Nawel</span></span>
          <span className="tk">Águas de Março — <em>Elis Regina &amp; Tom Jobim</em></span>
        </div>
        <span className="pf">DZR</span><span className="when">· 1h</span>
      </div>
      <div className="crow">
        <div className="av av-mossd">T</div>
        <div className="info">
          <span className="who"><span className="nm">Théo</span> · hier</span>
          <span className="tk">Setlist — <em>Nicola Cruz @ Sonár</em></span>
        </div>
        <span className="pf">SPO</span><span className="when">· 14h</span>
      </div>
    </Reveal>
  );
}

export function Preview() {
  return (
    <section className="block" data-screen-label="04 Aperçu">
      <div className="wrap">
        <div className="sec-head">
          <div><div className="sec-num"><b>04</b> &nbsp; aperçu</div></div>
          <div className="sec-tag">PRODUIT v0 — DESSIN, PAS CAPTURE</div>
        </div>
        <Reveal as="h2" className="sec-title">Ce que <em>tu verras.</em></Reveal>
        <Reveal as="p" className="sec-intro">
          Un feed unique. Tes amis, leurs morceaux, leurs apps — réunis dans le même fil, en temps réel.
        </Reveal>
        <div className="feed-grid">
          <Phone />
          <Console />
        </div>
      </div>
    </section>
  );
}
